var _rect, _rect2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuBurger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Outline",
    viewBox: "0 0 24 24",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 11,
    width: 24,
    height: 2,
    rx: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 4,
    width: 24,
    height: 2,
    rx: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 18,
    width: 24,
    height: 2,
    rx: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuBurger);
export default __webpack_public_path__ + "static/media/menu-burger.230ce7ebac47221f71ff65a4369a1d1e.svg";
export { ForwardRef as ReactComponent };